const useCurrentUserIsFriend = () =>{

    /*const queryClient = useQueryClient();
    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    let [enabled, setEnabled] = useState(false);
    let [isFriend, setIsfriend] = useState(false);

    useEffect(() =>{
        if(dataCurrentUser?._id){
            setEnabled(true);
        }
    }, [dataCurrentUser])

    useQuery(
        [USER_CURRENT_IS_FRIEND_KEY],
        ()=> fetchUserCurrentIsFriend(),
        {
            staleTime : (1000 * 60 * 5),
            enabled : enabled,
            onSuccess: (data) =>{
                setIsfriend(data.isFriend);
            }
        }
    );*/
    let isFriend = true;
    return [isFriend];
}

export default useCurrentUserIsFriend;